import React from 'react';
import { Pagination } from 'react-bootstrap';
import * as URI from 'urijs';
import { useNavigate } from 'react-router-dom';

export interface PagenateData {
  total: number;
  page: number;
  size: number;
}

function Pagenate(props: PagenateData) {
  let items = [<></>];
  let next = { disabled: false };
  let prev = { disabled: false };
  const uri = new URI.default(window.location.href);
  const navigate = useNavigate();

  if (props.total > 0) {
    const maxPage = Math.floor(props.total / props.size) + 1;

    items = Object.keys(
      Array.from({
        length: maxPage,
      })
    ).map((value) => {
      return (
        <Pagination.Item
          key={value.toString()}
          active={Number(value) === props.page}
          onClick={() => {
            if (Number(value) === props.page) {
              return;
            }

            uri.setQuery('page', value);
            navigate(uri.pathname() + uri.search());
          }}
        >
          {Number(value) + 1}
        </Pagination.Item>
      );
    });

    if (props.page + 1 >= maxPage) {
      next.disabled = true;
    }

    if (props.page - 1 < 0) {
      prev.disabled = true;
    }
  } else {
    return <></>;
  }

  return (
    <Pagination>
      {props.total > 0 ? (
        <Pagination.Prev
          {...prev}
          onClick={() => {
            uri.setQuery('page', Number(props.page) - 1);
            navigate(uri.pathname() + uri.search());
          }}
        />
      ) : (
        <></>
      )}
      {items}
      {props.total > 0 ? (
        <Pagination.Next
          {...next}
          onClick={() => {
            uri.setQuery('page', Number(props.page) + 1);
            navigate(uri.pathname() + uri.search());
          }}
        />
      ) : (
        <></>
      )}
    </Pagination>
  );
}

export { Pagenate };
